import { render } from "./Three3Charts.vue?vue&type=template&id=1a910af8&scoped=true"
import script from "./Three3Charts.vue?vue&type=script&lang=js"
export * from "./Three3Charts.vue?vue&type=script&lang=js"

import "./Three3Charts.vue?vue&type=style&index=0&id=1a910af8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a910af8"]])

export default __exports__